<template>
  <div>
    <v-card>
      <v-toolbar color class="mb-1">
        <v-toolbar-title v-if="isAdmin">Send SMS</v-toolbar-title>
        <v-toolbar-title v-else>Send Message</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn fab color="primary" x-small @click="openBulkSMSDialog()">
          <v-icon>mdi-comment</v-icon>
        </v-btn>
      </v-toolbar>
      <v-virtual-scroll
        :items="sentSMSes"
        height="400"
        item-height="120"
      >
        <template v-slot:default="props">
          <v-list-item :key="props.item.id">
            <v-list-item-content v-if="props.item">
              <v-list-item-title>{{ props.item.title }}</v-list-item-title>
              <v-list-item-subtitle class="text--primary">{{
                props.item.body
              }}</v-list-item-subtitle>
               <v-list-item-subtitle class="text--primary">{{
                props.item.date_time
              }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn x-small color="teal"
              rounded dark
               @click="reSendSMS(props.item)"
                >Resend</v-btn
              >
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
        </template>
      </v-virtual-scroll>
    </v-card>

    <GlobalDialogSlot
      :dialog="dialog"
      :title="sendSMSTitle"
      @close-dialog="closeDialog"
    >
      <SendSMS :groupTable="'clients'" :recipientsIDs="[client.id]" :selectedSentSMSItem="selectedSentSMSItem" @refresh-needed="getSentSMSForIndividual"></SendSMS>
    </GlobalDialogSlot>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
import SendSMS from "@/components/SMS/SendSMS.vue";

export default {
  props:['client'],
  components: {
    GlobalDialogSlot,
    SendSMS,
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  mounted(){
    this.getSentSMSForIndividual()
    },
  data() {
    return {
      sendSMSTitle:null,
      dialog: false,
      bulkSMS: false,
      sentSMSes:[],
      selectedSentSMSItem:null
    };
  },
  methods: {
    getSentSMSForIndividual(){
      this.$store.commit('setLoader',true)
      axios.postDataWithToken('/auth/get-sent-sms-for-individual',
      {
        client:this.client
      },this.getAccessToken).then(sentSMSes => {
        this.sentSMSes = sentSMSes
        this.$store.commit('setLoader',false)
        this.closeDialog()

      })
    },
    reSendSMS(item) {
      this.selectedSentSMSItem = item;
      this.dialog = true;
      this.bulkSMS = true;
      this.sendSMSTitle =
        "Resend SMS To " + this.item.delivered + " Recipients";
    },
    openBulkSMSDialog() {
      if ([this.selectedClientReference].length < 1) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
      } else {
          this.sendSMSTitle = 'Send SMS to '+ this.client.name
        this.dialog = true;
        this.bulkSMS = true;
      }
    },

    closeDialog() {
      this.dialog = false;
      this.bulkSMS = false;
      this.sendSMSTitle = null;
      this.selectedSentSMSItem = null;
    },
  },
};
</script>

<style></style>
